import { useState, useRef, useEffect } from "react";
import NepaliDatePicker from '@zener/nepali-datepicker-react';
import '@zener/nepali-datepicker-react/index.css';
import "./Filters.css";

export default function GrainFilters({
    filter,
    setFilter,
    grainNames,
    onClear,
    rowsPerPage,
    setRowsPerPage,
    sortBy,
    setSortBy
}) {
    const [showSort, setShowSort] = useState(false);
    const sortRef = useRef(null);

    const sortOptions = [
        { label: "Date Added (Newest)", value: "created_desc" },
        { label: "Date (Newest)", value: "date_desc" },
        { label: "Date (Oldest)", value: "date_asc" },
        { label: "Amount (High → Low)", value: "amount_desc" },
        { label: "Amount (Low → High)", value: "amount_asc" }
    ];

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (sortRef.current && !sortRef.current.contains(e.target)) {
                setShowSort(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="filters-slim">
            <div className="row g-2 align-items-end">
                {/* ROWS PER PAGE */}
                <div className="col-md-auto">
                    <select className="form-select" value={rowsPerPage} onChange={e => setRowsPerPage(Number(e.target.value))}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                {/* TYPE */}
                <div className="col-md-2">
                    <select className="form-select" value={filter.type} onChange={e => setFilter(prev => ({ ...prev, type: e.target.value }))}>
                        <option>All</option>
                        <option>Buy</option>
                        <option>Sell</option>
                    </select>
                </div>

                {/* GRAIN */}
                <div className="col-md-3">
                    <select className="form-select" value={filter.grain} onChange={e => setFilter(prev => ({ ...prev, grain: e.target.value }))}>
                        <option value="All">All Grains</option>
                        {grainNames.map(g => <option key={g}>{g}</option>)}
                    </select>
                </div>

                {/* FROM */}
                <div className="col-md-2">
                    <NepaliDatePicker
                        value={filter.from ? new Date(filter.from) : null}
                        onChange={(date) => {
                            if (date) {
                                const regularDate = date.toADasDate ? date.toADasDate() : date;
                                const year = regularDate.getFullYear();
                                const month = String(regularDate.getMonth() + 1).padStart(2, '0');
                                const day = String(regularDate.getDate()).padStart(2, '0');
                                const localDateString = `${year}-${month}-${day}`;
                                setFilter(prev => ({ ...prev, from: localDateString }));
                            } else {
                                setFilter(prev => ({ ...prev, from: '' }));
                            }
                        }}
                        placeholder="From Date"
                        className="form-control"
                        type="BS"
                    />
                </div>

                {/* TO */}
                <div className="col-md-2">
                    <NepaliDatePicker
                        value={filter.to ? new Date(filter.to) : null}
                        onChange={(date) => {
                            if (date) {
                                const regularDate = date.toADasDate ? date.toADasDate() : date;
                                const year = regularDate.getFullYear();
                                const month = String(regularDate.getMonth() + 1).padStart(2, '0');
                                const day = String(regularDate.getDate()).padStart(2, '0');
                                const localDateString = `${year}-${month}-${day}`;
                                setFilter(prev => ({ ...prev, to: localDateString }));
                            } else {
                                setFilter(prev => ({ ...prev, to: '' }));
                            }
                        }}
                        placeholder="To Date"
                        className="form-control"
                        type="BS"
                    />
                </div>

                {/* SORT BUTTON */}
                <div className="col-md-auto position-relative" ref={sortRef}>
                    <button className="filter-sort-btn" onClick={() => setShowSort(!showSort)}>
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={{ marginRight: "6px" }}>
                            <path d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2z" />
                            <path d="M3 6h10v1H3zM3 10h10v1H3z" />
                        </svg>
                        Sort
                    </button>
                    {showSort && (
                        <div className="filter-sort-menu">
                            {sortOptions.map(opt => (
                                <div
                                    key={opt.value}
                                    className="filter-sort-item"
                                    onClick={() => {
                                        setSortBy(opt.value);
                                        setShowSort(false);
                                    }}
                                >
                                    {opt.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* CLEAR */}
                <div className="col-md-1">
                    <button className="btn btn-outline-secondary w-100" onClick={onClear}>
                        Clear
                    </button>
                </div>
            </div>
        </div>
    );
}